import React from 'react'
import './Events.css';

const eventos = [

  {
    id: 1,
    titulo: "AQP TRAIL RUNNING 2026 - CUARTA SERIE: EL VALLE DE CHILINA",
    fecha: "25 de octubre 2026",
    lugar: "Valle de Chilina, Arequipa, Perú",
    descripcion: "¡Más allá de tus límites! Carrera de Trail Running en el Valle de Chilina - Arequipa",
    enlace: "/aqp_trs_chilina",
    imagen: "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/IMG_6805.PNG",
    disponible:true
  },  
  {
    id: 2,
    titulo: "YO CORRO POR LOS NIÑOS 2026",
    fecha: "13 de diciembre 2026",
    lugar: "Characato, Arequipa, Perú",
    descripcion: "Corre por una sonrisa, en esta carrera solidaria que apoya a los niños en situación de vulnerabilidad.",
    enlace: "/corro_ninos_2026",
    imagen: "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/NUEVO%20FLAYER.jpg",
    disponible:true
  },
];

const Events = () => {
  return (
    <section className="events-section">
      <h2>Próximos Eventos</h2>
      <div className="eventos-grid">
        {eventos.map((evento) => (
          <div key={evento.id} className="evento-card">
            <img src={evento.imagen} alt={evento.titulo} className="evento-img" />
            <h3>{evento.titulo}</h3>
            <p><strong>Fecha:</strong> {evento.fecha}</p>
            <p><strong>Lugar:</strong> {evento.lugar}</p>
            <p>{evento.descripcion}</p>
            {
              evento.disponible ? (

                <a
                  href={evento.enlace}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ver detalles e inscribirse
                </a>

              ) : (

                <button className="btn-proximamente">
                  Próximamente
                </button>

              )
            }
          </div>
        ))}
      </div>
    </section>
  );
};

export default Events;
